// this file added by Bearer Web Developer
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, Button, Link } from '@mui/material';
import styles from './cancelledByRiderAfterOrigin.module.scss';
import { useThemeMode } from '../../states/contexts/theme';
import { useAppState } from '../../states/app-state';
import DisabledClickLoading from '../../components/DisabledClickLoading';


const CancelledByRiderAfterOriginPopup: React.FC = observer(() => {

  const appState = useAppState();
  const cancellation = appState?.cancelledByRiderAfterOrigin;
  const [loading, setLoading] = useState(false);
  const handleCancellling = async () => {
    setLoading(true);
    await appState.selectedOrder?.customerCancelTransportAfterCancelByRider();
    setLoading(false);
  }
  const handleConfirm = async () => {
    cancellation.clear();
  };
  React.useEffect(() => {
    handleCancellling();
  }, []);

  const { theme } = useThemeMode(); // added by Bearer Web Developer
  return (
    // modified by Bearer Web Developer start
    <Dialog open={cancellation?.open} // true changed to !!snackMessage by Bearer Web Developer
      slotProps={{
        paper: {
          sx: {
            borderRadius: "10px",
            backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
          },
          classes: { root: styles.root }
        },
      }}
    >
      <div className={styles.main} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
        <div >
          <p>{cancellation?.message}</p>
        </div>
        <div className={styles.buttons}>
          <Button onClick={() => { handleConfirm() }} className={styles.button}>
            <span>OK</span>
          </Button>
          {loading && <DisabledClickLoading />} {/* added by Bearer Web Developer (for loading) */}
        </div>
      </div>
    </Dialog>
  );
});
export default CancelledByRiderAfterOriginPopup;
